import axios from "axios";

const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["x-auth-token"] = token;
  } else {
    delete axios.defaults.headers.common["x-auth-token"];
  }
};

const setRoleName = (roleName) => {
  if (roleName) {
    axios.defaults.headers.common["x-role-name"] = roleName;
    localStorage.setItem('profile', roleName);
  } else {
    delete axios.defaults.headers.common["x-role-name"];
    localStorage.removeItem('profile');
  }
};

export { setAuthToken, setRoleName };
